import { render, staticRenderFns } from "./BaseFieldWithUrl.vue?vue&type=template&id=253ad851"
import script from "./BaseFieldWithUrl.vue?vue&type=script&lang=js"
export * from "./BaseFieldWithUrl.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldWithUrl.vue?vue&type=style&index=0&id=253ad851&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports